module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('span', {
    staticClass: "stickup"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("3")])]), _vm._v(" The walk to school on Monday is eight blocks of winter memories. Charlie’s feet bring the world toward him slowly, so he can savor flavors long lost: earthy aromas, sharp slanting sunlight, crisp dry breezes, murmurs of Fords trailing their lead-rich blue exhaust.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He dreamed of the car crash, but now it seems to be just a dream. This world is real. It echoes, too—he is living this and remembering it at the same time. He has a curious double sensation of immersion in a recalled memory, while feeling that memory like a layer on the running present.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Back in the Charlie One life, after his father died they had to sell the house. Alone, his mother became depressed, sleeping all day, watching infomercials all night, unable to cope. Charlie and Catherine hoped that their mother’s girlfriends would stand by her once she was widowed, but they all faded away, clinging to their surviving husbands, perhaps fearful of Jane Moment’s lingering beauty and poignant vulnerability. Such a woman might easily tempt the heart of a man a few years older. They tried an apartment in the area for a while, then a small house near Catherine in Madison, Wisconsin. Nothing really worked for Jane.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Woodrow Wilson High played a large part in Charlie’s development—teaching him how to write essays, at least. That exposed ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("him to stories of injustice rarely seen in the leafy enclave where his father’s car-parts business provided his family with a good home. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Grapes of Wrath")]), _vm._v(" was Charlie’s favorite book. For him the ending was especially wrenching, the woman nursing the sick man and the dead baby being sent down the river. Part of Charlie stayed with the starving Okies, making their way across the country to the false promise of California. When Mr. Owen preached liberalism and reform from the blackboard in grade eleven, Charlie paid close attention.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He walks up the steps to the redbrick building the sunny day after his sixteenth birthday, his second sixteenth birthday, trembling inside. Charlie’s nostrils wrinkle at the commingled smells of hormones and cheap perfume filling the hallway to his locker—and feels the memory of it layer the experience. The banging metal doors, clicking heels, and cacophony of young voices dizzy him. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("My body is my guide now. Gut knowledge.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, Charlie, you ol’ fuckhead.” A handsome jock punches Charlie right in the middle of his chest. Charlie lets go of his books but squats quickly enough to grab them before they hit the floor. It’s Robert Woodson, his fake-tough buddy—who died, he recalls as he looks at Robert’s smooth face, in a terrible 1971 car crash fueled by fraternity-party alcohol. Here he is, back in the flesh—thick brown hair, quick smile, on top of the local pecking order.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sixteen and still a virgin, you loser.” Robert grins broadly and shoves Charlie down the hallway, turning away to bound off to class, his powerful legs springing along the polished hall floor, a superhero off to fight crime in the metropolis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlie shakes his head. “Not so,” he says to nobody. But he’s still reacting inside, with clashing responses from Charlies One and Two. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Robert! The jock!")]), _vm._v(" Charlie feels dizzy from his interior time swings. The Charlies fight for control. He breathes deeply.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robert is dead in that other now, dead in 2000—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Like me.")]), _vm._v(" Perhaps this "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("is")]), _vm._v(" a crazy afterlife?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Steadying, he recalls his locker number: 555. He’s already past it, doubles back and sees James standing at 557. Charlie glances sideways, has to stop. The sight of the pale James is almost supernatural in itself. Bony, big Adam’s apple, thick wrists and hands like dots at the ends of his thin arms making exclamation points, shirttail untucked, long stringy hair with dandruff like melting snow. Charlie takes a breath and walks up to James, who turns with a downcast, embarrassed gaze.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry, but I didn’t get you anything for your birthday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlie speaks softly to his friend from a perspective of decades, easy and low. The living speaking to the dead. “Hey, that’s all right, James.” James insisted on the dignity of his full name. He was institutionalized for progressive schizophrenia with catatonia. Or will be. His blond hair and pallor make him a ghost in Charlie’s eyes. Charlie wonders if he can make it through the day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just kidding.” James grins and reaches into his locker and pulls out a plastic-wrapped LP of Cream’s "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Disraeli Gears")]), _vm._v(", the huge cover a jumble of orange and red psychedelic images.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wow, with ‘White Room,’ ” Charlie comments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That song isn’t on this album, Charlie.” James looks confused. “ ‘Sunshine of Your Love,’ that’s the big song on the album. ‘White Room’?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think I heard that’s the new single.” Charlie Moment is panicking, afraid of being caught out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("James frowns.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A lanky boy with thick glasses yells at them as he walks by, “Ready for the test?” Charlie tries to remember who he is, but fails. Then he’s gone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What test?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The big history test, Charlie! You’re the brain! Hey, did you score some dope for your birthday, Charlie? Don’t tell me you gave it to Trudy, to get her to put out.” His slack-jawed shock seems genuine.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("“Trudy isn’t anything like that.”")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, okay. Lay off me, man.” Rolling eyes. “Like, I’m your best friend since sixth grade, you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("jerk")]), _vm._v(".” James gathers his books together and locks up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry, James. I didn’t sleep well this weekend.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, man. I’m getting a lot of headaches—can’t sleep worth shit myself.” He looks pointedly at Charlie’s open locker. “Don’t you think you should go to the test too?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The history exam covers the American Revolution and the Constitutional Convention. Charlie breezes through the five short-answer questions but sits stumped by the assigned essay. Mr. Owen wants five hundred words on the question of states’ rights in the framing of Congress? Maybe one hundred thousand would scratch the surface.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He buckles down to work, his loopy handwriting filling up line after line with fluid ease. Maybe education is wasted on the young. He looks up with a smile. He is a bit surprised to see Mr. Owen gazing wanly at him with soft eyes. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I wonder if he’s gay")]), _vm._v(", Charlie thinks. His teacher is wearing his usual black suit, threadbare and shiny, with a white shirt and thin black tie. Lincoln Owen was a major influence on Charlie, turning him from a soft-focus liberal to a radical just in time for the Chicago riots during the Democratic National Convention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Weird, looking down the long periscope of time at this, he thinks, drifting forward to that summer of 1968, still to come. The riots. His arrest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He brings himself back to the room by studying Owen, the thin neck and thinning hair. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("He looked so ancient to me")]), _vm._v(", Charlie thinks, realizing that Owen must be no older than his late thirties, a decade younger than Charlie One was, is, would be. Charlie sighs out loud. The cute blonde next to him gives him a scowl. What was her name?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("He returns to his essay with a surge of libidinal energy and within the allotted time period has an essay that he can live with. He hands it ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("in to Mr. Owen with a conspiratorial smile, but the teacher looks startled. Charlie realizes that he isn’t acting like a high school student, and proceeds to slouch out of the class with the appropriate degree of insolent apathy—shoulders hunched, mouth twisted scornfully. Years of college teaching have given him many role models for the ritual indifference of the young.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "secbreak"
  }, [_vm._v("*  *  *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Charlie wakes up in the night and wonders where his paunch is, why his body feels strange, vibrant. Then he remembers what has happened, and feels an odd wash of nostalgia for his older self. Charlie One made his way in the world, struggled over the hurdles. There was some achievement in that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The feeling passes. He realizes that he has to get on with his new life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Has anyone else ever had to do this?")]), _vm._v(" he wonders.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("*  *  *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("James and Charlie are watching basketball on the television in the basement of James’s house. The image is so low grade it is like watching the game through a kaleidoscopic snowstorm. James’s parents are much older. They always seemed surprised to have James living with them, and the fact that he had even one friend was obviously a miracle to their eyes. They generally left him alone downstairs. It makes Charlie think that perhaps James was adopted, but he never learned anything about it the last time. The last time, Charlie wonders, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("was")]), _vm._v(" there a last time?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Man, were you adopted?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("James starts coughing and quickly hands Charlie the tiny roach that he was toking off. “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know, your parents. They’re hardly aware that you exist.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We can’t all have dads who’re Fred MacMurray.” James seems hurt, pushing some of his blond hair behind his left ear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, man. I’m sorry.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("“Yeah . . . uh, well . . . I was. My birth mother was a teenager, they ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("tell me. No way to raise me, so she gave me to an agency.” Now James is like a deflated balloon, air rushing out from his admission.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlie takes a toke off the clipped roach, feeling a need for some self-medication in his new life. “That’s tough, man. Real tough.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He makes no move toward comforting James. He remembers that James doesn’t like to be touched.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Their evening basketball broadcast is interrupted by a newsman with hollow eyes and what looks like bright-orange makeup. “This just in from the Pentagon. The USS "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Pueblo")]), _vm._v(" has been taken by the naval forces of North Korea. President Johnson has ordered the aircraft carrier "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Enterprise")]), _vm._v(" to proceed toward the area. More news at eleven. We now return you to your regularly scheduled programming.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("James says, “Fuck, man! Those commies are doing it again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlie laughs. “Commies?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, like first in Vietnam—well, maybe first in Korea. But now they’re acting up again in Korea, too. Johnson has to get tough.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you talking about, James? Vietnam is a lost cause. It’s a civil war between the communists and the corrupt South Vietnamese regime.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("James rises up from his ancient sofa, his posture quite rigid, the rims of his eyes red. “Stop with that shit! I am so sick of your attitude. Don’t you care about your country?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a sense of shock echoing through the paradox of time, Charlie snaps into the present, a 1968 rife with intense polarization. Vietnam is a bleeding wound in the American psyche, and the pain of it will touch everyone. James will soon be drafted and go to Nam. There his mind will fray beyond recovery from the killing and the lies, starting his long slide toward psychiatric oblivion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s all right, man. I’m on your side.”")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("*  *  *")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Late the following Sunday afternoon, Charlie takes a long shower after spending the afternoon on driver’s training. He has a driver’s ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("exam scheduled soon. To his surprise, he still has to pick up some of the wary road skills. Muscle memory, he guesses. It isn’t all in the brain. The warmth, moisture, and relaxation of the shower let him reflect with some peace of mind.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("This can’t be a dream.")]), _vm._v(" Dreams don’t last so long, with so much consistent detail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He wonders if he has died and gone on to the next life. But going back to live your life again doesn’t fit with any biblical conception of heaven, hell, or purgatory. It seems more like Hinduism. But you are supposed to go up or down the karmic ladder, not repeat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A thumping on the bathroom door. He hears his father’s muffled voice but can’t make out the words. He turns off the comforting water and steps out of the bathtub.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now he can hear what his father is saying. “. . . overrunning American positions all through South Vietnam. We’re taking a lot of casualties. You should see it, Charlie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, Dad. I’ll be right down.” January 30, the 1968 Tet Offensive. The final nail in the coffin of the Johnson administration. Charlie thinks briefly about all the good things that LBJ managed to accomplish before Vietnam sucked him into rigid anticommunism. Then he gets dressed in jeans and a T-shirt to join his father in front of the TV.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("*  *  *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The rest of the week brings the war in Vietnam back to Charlie with a ferocity he had forgotten by 2000, even though he worked for Eugene McCarthy’s 1968 campaign as a volunteer. He spends a week wondering if he should do it again.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("And then a day or so into the Tet Offensive, he sees the defining footage. Again. February 1: A South Vietnamese officer drags a Vietcong prisoner in front of the American cameras and executes him with his pistol. Right there, in front of millions of people. The networks play the scene over and over again, until it becomes part of Charlie’s dream-life, the instant when the victim crumples to ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("the ground, his face locked in a grimace, dead. The man had set off bombs, killing many in an apartment building. There would be no peace in Southeast Asia. The war would go on and on. So many American lives would be lost. We would never give up. All the millions who would die, who "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("did")]), _vm._v(" die . . .")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlie grows tired of thinking about time in two directions and resolves to think about his past in Washington, DC, as the future. Perhaps even a future that will never happen. Whatever brought him here, catatonic insanity or a cyclic afterlife, he accepts that 1968 is his present.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5ecf8ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 90
// module chunks = 0